var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass:
        "translation-btn h-full flex items-center gap-1.5 transition-all",
      on: { click: _vm.onOpenTranslationModal },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-full h-full flex justify-center items-center relative",
        },
        [
          _c("GrmIcon", {
            class: [
              "z-10",
              // {'animate-ping': translationState}
            ],
            attrs: {
              icon: `menu-translation-${_vm.translationState ? "on" : "off"}`,
              size: "full",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }